import { initSentry } from './saas/sentry';
import { AppConfig } from './types';
import loadCookie from './utils/cookie';

const appConfig = loadCookie<AppConfig>('app_config');
if (appConfig) {
  initSentry(appConfig);
}
